/**
 * Created by rvvslv on 13.01.21.
 */

const AvatarMenuBarView = MenuBarItemView.extend({
    ctor: function (item) {
        this._super(item);

        this.setAnchorPoint(0.5, 0.5);

        item.onChangeLevelNo = this.createListener(this.onChangeLevelNo.bind(this));
        item.onChangeExpProgress = this.createListener(this.onChangeExpProgress.bind(this));

        cleverapps.settings.on("changedAvatar", this.updateAvatar.bind(this), this);
    },

    updateAvatar: function () {
        if (this.avatar) {
            this.avatar.removeFromParent();
        }

        this.mode = cleverapps.resolution.mode;

        this.avatar = this.createAvatar();
        this.container.addChild(this.avatar);
        this.container.setContentSize2(this.avatar.getContentSize());
        this.avatar.setPosition(this.container.width / 2, this.container.height / 2);

        this.setContentSize2(this.avatar.width, cleverapps.styles.AvatarMenuBarView.height);
        this.container.doAlignment();
    },

    getAvatarSize: function () {
        const styles = cleverapps.styles.AvatarMenuBarView.avatar;
        return connector.info.isMobile && styles.mobileSize || styles.size;
    },

    onResize: function () {
        const styles = cleverapps.styles.AvatarMenuBarView;
        const modeDependent = Array.isArray(this.getAvatarSize()) || Array.isArray(styles.height);

        const levelStyles = this.getLevelStyles();
        if (this.level && levelStyles.scale) {
            this.level.setScale2(levelStyles.scale);
            this.level.baseScale = this.level.getScale();
            this.level.doAlignment();
        }

        if (modeDependent && this.mode !== cleverapps.resolution.mode) {
            this.updateAvatar();

            if (this.progress) {
                this.progress.setLength(this.getProgressWidth());
                this.progress.doAlignment();
            }
        }
    },

    reset: function () {
        const styles = cleverapps.styles.AvatarMenuBarView;

        this.removeAllChildren();
        this.avatar = undefined;

        const container = this.container = new cc.Node();
        container.setAnchorPoint(0.5, 0.5);
        container.setAlignment(styles.avatar);

        this.addChild(container);

        this.updateAvatar();

        if (this.item.withLevel()) {
            this.level = this.createLevel();
            this.progress = this.createProgress();

            container.addChild(this.progress);
            container.addChild(this.level);

            this.onResize();
            this.onChangeLevelNo();
            this.updateProgress(true);

            this.addAction();
        }

        SceneDecors.add(this, cleverapps.skins.getSlot("menuBarLevelItem"));
    },

    createAvatar: function () {
        const styles = cleverapps.styles.AvatarMenuBarView.avatar;

        const player = { ...connector.player, ...{ avatar: cleverapps.settings.getAvatar() } };
        const external = cleverapps.UI.Avatar.IsExternal(player.avatar);

        const avatar = new cleverapps.UI.Avatar(player, {
            padding: styles.padding,
            size: this.getAvatarSize(),
            useBigImage: true,
            useFrame: false,
            foreground: external ? bundles.menubar.frames.menubar_avatar_foreground_png : undefined,
            rounded: external
        });

        if (typeof ProfileWindow !== "undefined" && ProfileWindow.IsSelectionAvailable()) {
            cleverapps.UI.onClick(avatar, () => {
                cleverapps.focusManager.display({
                    focus: "ProfileWindow",
                    action: (f) => {
                        new ProfileWindow();
                        cleverapps.focusManager.onceNoWindowsListener = f;
                    }
                });
            });
        }

        avatar.setAlignment(styles);

        return avatar;
    },

    getIcon: function () {
        return this.level || this.avatar;
    },

    getLevelStyles: function () {
        const locationId = cleverapps.meta.selectedLocationId();
        return cleverapps.styles.AvatarMenuBarView.level[locationId] || cleverapps.styles.AvatarMenuBarView.level;
    },

    createLevel: function () {
        const styles = this.getLevelStyles();

        const bg = new cc.Sprite(cleverapps.skins.getSlot("menubar_round_bg_png") || bundles.menubar.frames.menubar_round_bg_png);

        bg.setAlignment(styles.alignment || styles);

        this.levelText = cleverapps.UI.generateImageText("", cleverapps.styles.FONTS.MENUBAR_LEVEL_WITH_AVATAR_TEXT);
        this.levelText.setAlignment(styles.text);
        bg.addChild(this.levelText);

        bg.setLocalZOrder(1);

        return bg;
    },

    getProgressWidth: function () {
        const styles = cleverapps.styles.AvatarMenuBarView.progress;
        const width = connector.info.isMobile && styles.mobileWidth || styles.width;
        return Array.isArray(width) ? width[cleverapps.resolution.mode] : width;
    },

    createProgress: function () {
        const styles = cleverapps.styles.AvatarMenuBarView.progress;

        const progress = new ScaledProgressBar({
            type: cleverapps.gameLevel.withOwnLevel() ? ScaledProgressBar.Types.blue_menu_bar_level : ScaledProgressBar.Types.green_menu_bar_level
        });

        progress.setLength(this.getProgressWidth());
        progress.setAlignment(styles);

        cleverapps.tooltipManager.create(progress, {
            content: () => this.createTooltipContent(),
            location: cleverapps.UI.Tooltip.LOCATION_BELOW,
            contentSize: this.createTooltipContent().getContentSize()
        });

        progress.setLocalZOrder(1);

        return progress;
    },

    createTooltipContent: function () {
        const styles = cleverapps.styles.AvatarMenuBarView.toolTipContent;

        const value = this.item.getCurrentValue();

        const textBlock = new cleverapps.Layout([
            cleverapps.UI.generateOnlyText(Messages.get("AvatarMenuBarView.tooltipText"), cleverapps.styles.FONTS.MENUBAR_TOOLTIP_TEXT),
            cleverapps.UI.generateImageText(`${value.amount} / ${value.total}`, cleverapps.styles.FONTS.MENUBAR_TOOLTIP_NUMBERS_TEXT)
        ], {
            direction: cleverapps.UI.VERTICAL
        });

        const icon = new cc.Sprite(cleverapps.skins.getSlot("menubar_round_bg_png") || bundles.reward_icons.frames.reward_exp_small_png);

        return new cleverapps.Layout([icon, textBlock], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.margin
        });
    },

    updateProgress: function (silent) {
        const progress = this.progress;

        const value = this.item.getCurrentValue();

        progress.setGoal(value.total);
        progress.setPercentage(value.amount, {
            animated: !silent
        });
    },

    onChangeExpProgress: function () {
        const effect = cleverapps.skins.getSlot("expFlyFinishEffect");
        if (effect) {
            cleverapps.effects.fire(effect);
        }
        this.updateProgress();
    },

    onChangeLevelNo: function () {
        const styles = cleverapps.styles.AvatarMenuBarView;

        this.levelText.setString(this.item.getCurrentValue().level);
        this.levelText.fitTo(styles.level.text.width, 0);
    },

    addAction: function () {
        if (cleverapps.config.debugMode) {
            cleverapps.UI.onClick(this.level, this.item.debugAction);
        }
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    MENUBAR_LEVEL_TEXT: {
        name: "default",
        size: 86
    },

    MENUBAR_PROGRESS_TEXT: {
        name: "default",
        size: 52
    },

    MENUBAR_LEVEL_WITH_AVATAR_TEXT: {
        name: "default",
        size: 39
    },

    MENUBAR_TOOLTIP_TEXT: {
        name: "default",
        size: 27
    },

    MENUBAR_TOOLTIP_NUMBERS_TEXT: {
        name: "default",
        size: 36
    }
});

cleverapps.styles.AvatarMenuBarView = {
    height: 65,

    level: {
        text: {
            width: 90
        }
    }
};
